<app-hvb-header></app-hvb-header>
<hr class="mb-0">
<div class="contact-page">
  <div class="title">
    {{'contactPage.title' | translate}}
  </div>
  <div class="subtitle">
    {{'contactPage.name' | translate}}<br><br>
  </div>
  {{'contactPage.street' | translate}}<br>
  {{'contactPage.postalCode' | translate}}<br>
  {{'contactPage.telephone' | translate}}<br>
  {{'contactPage.fax' | translate}}<br><br>
  {{'contactPage.email' | translate}}<br>
  {{'contactPage.website' | translate}}<br><br>
  <b>{{'contactPage.managingDirector' | translate}}</b>
  <br>
  {{'contactPage.managingDirectorName' | translate}}<br><br>
  <b>{{'contactPage.deputyManagingDirector' | translate}}</b>
  <br>
  {{'contactPage.deputyManagingDirectorName' | translate}}<br>
  {{'contactPage.deputyManagingDirectorTelephone' | translate}}<br><br>
</div>
<hvb-footer></hvb-footer>
